
const assetHost = process.env.ASSET_HOST || 'https://seats.rufftuff.com'

function getBaseSeat(variation) {
  return `${assetHost}/seats/${variation.ssSeatTypeCode}/${variation.ssSeatTypeCode}_base_seat.png`
}

function getOverlay(seat, cut) {
  return `${assetHost}/seats/${seat.ssSeatTypeCode}/${seat[cut].materialProductCode.toLowerCase()}-${seat[cut].colorProductCode}-${cut}.png`
}

function getDiamondQuilt(seat) {
  const option = seat.options?.find(
    o => o.style?.name?.toLowerCase() === 'diamond' && o.added
  )

  if (!option) return null

  return `${assetHost}/seats/${seat.ssSeatTypeCode}/${seat.insert.materialProductCode.toLowerCase()}-${seat.insert.colorProductCode}-dq-insert.png`
}

function getTile(color) {
  return `${assetHost}/tiles/${color.materialProductCode}-${color.colorProductCode}.jpg`
}

const materialsDescriptions = {
  camo: 'Authentic patterns from the top names in the camo industry. Hides dirt and grease stains until you can clean them up',
  carbonfiber: 'Known for light weight and strength. Multidimensional texture with sophisticated metallic colors',
  duraezcare: 'Wears like iron, fits like a glove. Highly water- and abrasion-resistant. Cleans easily with a damp cloth.',
  exotics: 'For inserts only. Looks like premium exotic animal leather. Water-repellent, UV colorfast, extremely durable.',
  neosupreme: 'Extra padding and comfort and water-resistant, without the odor and fading of neoprene.',
  perforatedsoftouch: 'Look and feel of leather. Try this for inserts, with Sof-Touch for Trim.',
  saddleblanket: 'A durable classic, sun- and mildew-resistant. Accessories come in color-matched vinyl',
  softouch: 'Luxurious simulated leather with a visible grain. Water- and mildew-resistant, with UV-stabilized pigments.',
  tactical: 'Fresh, 21st century, professional look. Highly water- and stain-resistant. Stands up to heavy use.',
  tweed: 'Tightly woven, durable material for comfort and superior wear. Resists snags, sagging, and slipping.',
  velour: ''
}

function getDescription(material) {
  return materialsDescriptions[material]
}

const optionMap = {
  DiamondQuilting: {
    image: 'https://seats.rufftuff.com/packages/diamond-quilting.jpg',
    details: 'Diamond Quilting has an elegant look that resembles original seats often found in high-end vehicles. It is available for inserts only (not trim), and only with inserts in these fabrics: Sof-Touch, Perforated Sof-Touch, Carbon Fiber, and Exotics.',
  },
  DoubleDiamondQuilting: {
    image: 'https://seats.rufftuff.com/packages/diamond-quilting.jpg',
    details: 'Double Diamond Quilting has an elegant look that resembles original seats often found in high-end vehicles. It is available for inserts only (not trim), and only with inserts in these fabrics: Sof-Touch, Perforated Sof-Touch, Carbon Fiber, and Exotics.',
  },
  HexQuilting: {
    image: 'https://seats.rufftuff.com/packages/diamond-quilting.jpg',
    details: 'Hex Quilting has an elegant look that resembles original seats often found in high-end vehicles. It is available for inserts only (not trim), and only with inserts in these fabrics: Sof-Touch, Perforated Sof-Touch, Carbon Fiber, and Exotics.',
  },
  ChainQuilting: {
    image: 'https://seats.rufftuff.com/tiles/chain-stitch-500x500.png',
    details: 'Chain Quilting has a unique linked pattern resembling chain stitching, available for inserts only (not trim). It can be used with Sof-Touch, Perforated Sof-Touch, Carbon Fiber, or Exotics fabrics.',
  },
  CableQuilting: {
    image: 'https://seats.rufftuff.com/packages/cable-stitch.png',
    details: '',
  },
  OneHeadrestCover: {
    image: '',
    details: '',
    qty: 1,
    alias: 'HeadrestCovers'
  },
  TwoHeadrestCovers: {
    image: 'https://seats.rufftuff.com/packages/two-headrests.jpg',
    details: 'On seats with adjustable headrests the covers for those headrests are sold separately.  Please note that if you have DVDs in the back of your headrests, you will need to select the seat option that mentions the DVDs in the headrests to ensure the accommodations are made for those DVDs.  In addition, if your seat option mentions non-removable headrests, then accommodations will be made on your backrest to allow your seat covers to be put on without removing the headrests.',
    qty: 2,
    alias: 'HeadrestCovers'
  },
  ThreeHeadrestCovers: {
    image: 'https://seats.rufftuff.com/packages/two-headrests.jpg',
    details: 'On seats with adjustable headrests the covers for those headrests are sold separately.  Please note that if you have DVDs in the back of your headrests, you will need to select the seat option that mentions the DVDs in the headrests to ensure the accommodations are made for those DVDs.  In addition, if your seat option mentions non-removable headrests, then accommodations will be made on your backrest to allow your seat covers to be put on without removing the headrests.',
    qty: 3,
    alias: 'HeadrestCovers'
  },
  FourHeadrestCovers: {
    image: 'https://seats.rufftuff.com/packages/two-headrests.jpg',
    details: 'On seats with adjustable headrests the covers for those headrests are sold separately.  Please note that if you have DVDs in the back of your headrests, you will need to select the seat option that mentions the DVDs in the headrests to ensure the accommodations are made for those DVDs.  In addition, if your seat option mentions non-removable headrests, then accommodations will be made on your backrest to allow your seat covers to be put on without removing the headrests.',
    qty: 4,
    alias: 'HeadrestCovers'
  },
  LargeArmrestCover: {
    image: 'https://seats.rufftuff.com/packages/large-armrest.jpg',
    details: 'A large armrest is a fold-out piece of your seat that is usually attached to the backrest.  It may or may not have cutouts for cupholders or a separate piece for an opening lid depending on the specific design for your armrest.  Covers for these are sold separately.  If you do not order the cover for the armrest, the piece will be left uncovered so you retain access to the armrest.',
    qty: 1,
    alias: 'LargeArmrestCovers'
  },
  OneSmallArmrestCover: {
    image: 'https://seats.rufftuff.com/packages/package-smallarmrest.jpg',
    details: 'Small armrests are folding arms attached on the sides of seats.  Each armrest cover is sold separately.  If you do not order the cover for the small armrest(s), they will be left uncovered. Armrest covers are options. They are only included with your seat covers if you select them on this page.',
    qty: 1,
    alias: 'SmallArmrestCovers'
  },
  TwoSmallArmrestCovers: {
    image: 'https://seats.rufftuff.com/packages/package-smallarmrest.jpg',
    details: 'Small armrests are folding arms attached on the sides of seats.  Each armrest cover is sold separately.  If you do not order the cover for the small armrest(s), they will be left uncovered. Armrest covers are options. They are only included with your seat covers if you select them on this page.',
    qty: 2,
    alias: 'SmallArmrestCovers'
  },
  ThreeSmallArmrestCovers: {
    image: 'https://seats.rufftuff.com/packages/package-smallarmrest.jpg',
    details: 'Small armrests are folding arms attached on the sides of seats.  Each armrest cover is sold separately.  If you do not order the cover for the small armrest(s), they will be left uncovered. Armrest covers are options. They are only included with your seat covers if you select them on this page.',
    qty: 3,
    alias: 'SmallArmrestCovers'
  },
  FourSmallArmrestCovers: {
    image: 'https://seats.rufftuff.com/packages/package-smallarmrest.jpg',
    details: 'Small armrests are folding arms attached on the sides of seats.  Each armrest cover is sold separately.  If you do not order the cover for the small armrest(s), they will be left uncovered. Armrest covers are options. They are only included with your seat covers if you select them on this page.',
    qty: 4,
    alias: 'SmallArmrestCovers'
  },
  OneLegrestCover: {
    image: 'https://seats.rufftuff.com/packages/package-single-pocket.jpg',
    details: 'Legrests are large lazy-boy style attachments that fold-out from the seat bottom.  Covers for the legrest portion of the seat are sold separately.  If you do not order the cover for the legrest, is will be left uncovered.',
    qty: 1,
    alias: 'LegrestCovers'
  },
  TwoLegrestCovers: {
    image: 'https://seats.rufftuff.com/packages/package-single-pocket.jpg',
    details: 'Legrests are large lazy-boy style attachments that fold-out from the seat bottom.  Covers for the legrest portion of the seat are sold separately.  If you do not order the cover for the legrest, is will be left uncovered.',
    qty: 2,
    alias: 'LegrestCovers'
  },
  HardConsoleLidCover: {
    image: 'https://seats.rufftuff.com/packages/package-console-cover.jpg',
    details: 'The Hard Console Lid Cover is a cover for the hard plastic console located between two bucket seats.  The lid cover fits over the lid and fastens securely, protecting it from damage and helping to match the color of the seat covers.',
    qty: 1,
    alias: 'HardConsoleLidCover'
  },
  TacticalPackage: {
    image: 'https://seats.rufftuff.com/packages/package-special-ops.jpg',
    details: 'The Ruff Tuff Special OPS (Outdoor Pocket System) Package is an accessory that can be added to your seat cover and sewn into the backrest of the front seat. Each side of the Special OPS™ Package comes with two pouches that open on the sides, used to store long items like rifles, fishing rods, or tools.  In addition, they come with 3 rows of MOLLE loops, a carabiner that can be used to hang items off the back of the seat, and two pockets with Velcro flaps used to store smaller items.<br><br>Newly redesigned, the Special OPS™ Package now has fold-down pockets and straps to hold compound bow or crossbow on each side. When not in use, the new pockets fold up out of sight.',
    warning: 'The Special OPS Package is available only if Camo or Dura EZ is selected for trim, and it cannot be ordered with rear pockets for the same seat.',
    qty: 1,
    alias: 'tacticalPackage'
  },
  PistolPocket: {
    image: 'https://seats.rufftuff.com/packages/package-pistolpockets.jpg',
    details: 'Pistol Pockets are a great option for storing a pistol on the front of your seat. The pocket is designed to hold one pistol and two magazines.  They work for either left or right-handed users.  They are equipped with Velcro, making the pocket detachable from the seat.  Each pocket is padded and lined with velour to protect the pistol from wear and damage.',
    qty: 1,
    alias: 'PistolPocket'
  },
  TwoPistolPockets: {
    image: 'https://seats.rufftuff.com/packages/package-pistolpockets.jpg',
    details: 'Pistol Pockets are a great option for storing a pistol on the front of your seat. The pocket is designed to hold one pistol and two magazines.  They work for either left or right-handed users.  They are equipped with Velcro, making the pocket detachable from the seat.  Each pocket is padded and lined with velour to protect the pistol from wear and damage.',
    qty: 2,
    alias: 'PistolPocket'
  },
  OneFrontPocket: {
    image: 'https://seats.rufftuff.com/packages/package-single-pocket.jpg',
    details: 'Front pockets are located on the front of the seat bottom behind your knees.  They are normally 6 in. deep and are ideal for storing small items like phones, wallets, or mini notepads. Front pockets and pistol pockets can be ordered individually (for either driver or passenger side) or in pairs (for both sides). If you order them individually, use the Additional Info box on the next page to designate which side (driver or passenger). Note that a pistol pocket and a regular front pocket cannot both be on the same side.',
    warning: 'A front pocket and a pistol pocket cannot be placed on the same side (driver or passenger) of a seat.',
    qty: 1,
    alias: 'FabricPocketFront'
  },
  TwoFrontPockets: {
    image: 'https://seats.rufftuff.com/packages/package-single-pocket.jpg',
    details: 'Front pockets are located on the front of the seat bottom behind your knees.  They are normally 6 in. deep and are ideal for storing small items like phones, wallets, or mini notepads. Front pockets and pistol pockets can be ordered individually (for either driver or passenger side) or in pairs (for both sides). If you order them individually, use the Additional Info box on the next page to designate which side (driver or passenger). Note that a pistol pocket and a regular front pocket cannot both be on the same side.',
    warning: 'A front pocket and a pistol pocket cannot be placed on the same side (driver or passenger) of a seat.',
    qty: 2,
    alias: 'FabricPocketFront'
  },
  OneRearPocket: {
    image: 'https://seats.rufftuff.com/packages/two-rear-pockets.jpg',
    details: 'Rear pockets are located on the back of the seats.  They are normally 18 in. deep and are ideal for storing toys, maps, flashlights, clipboards, or other items on the back of the seat.',
    warning: 'Rear pockets and a scabbard (if available) cannot be included on the same seat cover.',
    qty: 1,
    alias: 'FabricPocketRear'
  },
  TwoRearPockets: {
    image: 'https://seats.rufftuff.com/packages/two-rear-pockets.jpg',
    details: 'Rear pockets are located on the back of the seats.  They are normally 18 in. deep and are ideal for storing toys, maps, flashlights, clipboards, or other items on the back of the seat.',
    warning: 'Rear pockets and a scabbard (if available) cannot be included on the same seat cover.',
    qty: 2,
    alias: 'FabricPocketRear'
  },
  // 'FrontScabbard': { qty: 1, alias: 'ScabbardFront' },
  // 'RearScabbard': { qty: 1, alias: 'ScabbardRear' },
}

const accessoryMap = {
  FLEX: {
    image: 'https://seats.rufftuff.com/packages/flex.jpg',
    details: 'The Flex OPS™ Package is a seat-back organization system with various pockets and with three rows of MOLLE loops to accommodate a wide variety of third-party accessories. Flex OPS™ is uniquely designed to carry compound bows and crossbows, using fold-down pockets which hide when not in use. Its scabbard-style pockets carry rifles, shotguns, fishing rods, surveying equipment, and other long items across the back of both seats.',
    warning: 'The Flex OPS Package comes with driver- and passenger-side units. It can only be used on vehicle seats with adjustable headrests. It is not part of a seat cover, and can be easily moved from vehicle to vehicle. It is available only in our tough Black Dura EZ-Care fabric, which resists water and abrasion and cleans easily with a damp cloth.'
  },
  CAPRT01: {
    image: 'https://seats.rufftuff.com/packages/cap-01.jpg',
    details: 'RT Black Flat Bill Snapback Cap w/ Gray Flag Logo',
  },
  CAPRT02: {
    image: 'https://seats.rufftuff.com/packages/cap-02.jpg',
    details: 'RT Gray Billets Cap w/ Black & Red Circular Logo',
  },
  CAPRT03: {
    image: 'https://seats.rufftuff.com/packages/cap-03.jpg',
    details: 'RT Black Richardson 112 Trucker Cap w/ Gray Flag Logo',
  },
  CAPRT04: {
    image: 'https://seats.rufftuff.com/packages/cap-04.jpg',
    details: 'RT Navy Flat Bill Snapback Cap w/ Navy Flag Logo',
  },
  CAPRT05: {
    image: 'https://seats.rufftuff.com/packages/cap-05.jpg',
    details: 'RT Gray Richardson 112 Trucker Cap w/ Script RT Hexagon',
  },
  CAPRT06: {
    image: 'https://seats.rufftuff.com/packages/cap-06.jpg',
    details: 'RT Gray Flat Bill Snapback Cap w/ Script RT Hexagon',
  },
  CAPRT07: {
    image: 'https://seats.rufftuff.com/packages/cap-07.jpg',
    details: 'RT Camo & Black Flat Bill Snapback Cap w/ Brown Flag Logo',
  },
  CAPRT08: {
    image: 'https://seats.rufftuff.com/packages/cap-08.jpg',
    details: 'RT Blue & White Curved Bill Snapback Cap w/ Navy Flag Logo',
  },
  CAPRT09: {
    image: 'https://seats.rufftuff.com/packages/cap-09.jpg',
    details: 'RT Light Camo Curved Bill Snapback Cap w/ Brown Flag Logo',
  },
  CAPRT10: {
    image: 'https://seats.rufftuff.com/packages/cap-10.jpg',
    details: 'RT Black Flat Billets Cap w/ Black & Red Circular Logo',
  },
  CAPRT11: {
    image: 'https://seats.rufftuff.com/packages/cap-11.jpg',
    details: 'RT Dark Grey/Black Flat Bill Billets Cap w/ Black & Red Circular Logo',
  },
  CAPRT50: {
    image: 'https://seats.rufftuff.com/packages/cap-50.jpg',
    details: 'Ruff Tuff 50th Anniversary Cap',
  },
};

function filterOptions(variation, optionList) {
  let results = []
  for (let prop in variation) {
    for (let opt in optionList) {
      if (variation[prop] === true) {
        if ((prop === 'DiamondQuilting' && opt.indexOf('Quilting') > 0) || prop.toLowerCase() === opt.toLowerCase()) {
          results.push(Object.assign({name: opt}, {added: false}, {price: 0}, optionList[opt], optionMap[opt]))
        }
      }
    }
  }
  return results
}

const quiltStyles = [
  {
    name: 'Diamond',
    part: 'DIAQ',
    id: 1,
    image: 'https://seats.rufftuff.com/tiles/diamond-500x500.png',
  },
  {
    name: 'Hex',
    part: 'HEXQ',
    id: 3,
    image: 'https://seats.rufftuff.com/tiles/hex-500x500.png',
  },
  {
    name: 'Double Diamond',
    part: 'DDIQ',
    id: 2,
    image: 'https://seats.rufftuff.com/tiles/diamond-double-500x500.png',
  },
  {
    name: 'Chain',
    part: 'CHNQ',
    id: 4,
    image: 'https://seats.rufftuff.com/tiles/chain-stitch-500x500.png',
  },
  {
    name: 'Cable',
    part: 'CABQ',
    id: 5,
    image: 'https://seats.rufftuff.com/tiles/cable-stitch.png',
  },
  {
    name: 'Horizontal Quilting ($0)',
    id: 0,
    image: 'https://seats.rufftuff.com/tiles/None-500x500.png',
  },
]

export {
  getBaseSeat,
  getOverlay,
  getDiamondQuilt,
  getTile,
  getDescription,
  filterOptions,
  quiltStyles,
  accessoryMap
}
